import { SimpleGrid } from "@mantine/core";
import {
  StartPageTileDisplay_mode,
  StartPageTileName,
  StartPageTileSize
} from "../../../types/api.types";
import { LoadingTile } from "../MySitesInNumbers/LoadingTile";
import type { StartPageTile } from "../StartPage.types";
import { OnboardingProgressTile } from "./OnboardingProgressTile";
import { RegulatoryTodosTile } from "./RegulatoryTodosTile";
import { SiteSetupProcessesTile } from "./SiteSetupProcessesTile";

const TILES_TO_COMPONENT_MAP = {
  [StartPageTileName.OnboardingProgress]: OnboardingProgressTile,
  [StartPageTileName.RegulatoryTodos]: RegulatoryTodosTile,
  [StartPageTileName.SiteSetupProcesses]: SiteSetupProcessesTile
};

interface MySitesManagementProps {
  projectId?: string;
  tiles?: Array<StartPageTile>;
}

function MySitesManagement({ projectId, tiles }: MySitesManagementProps) {
  if (!tiles) {
    return <LoadingTiles />;
  }

  const tilesToDisplay = tiles.filter(
    (tile) => tile.display_mode !== StartPageTileDisplay_mode.Hide
  );
  return (
    <>
      <SimpleGrid className="MySitesManagement" cols={1} mb="lg" spacing="lg">
        {tilesToDisplay
          .filter((tile) => tile.size === StartPageTileSize.Large)
          .map((tile) => {
            const TileComponent =
              TILES_TO_COMPONENT_MAP[
                tile.name as keyof typeof TILES_TO_COMPONENT_MAP
              ];
            return <TileComponent key={tile.name} projectId={projectId} />;
          })}
      </SimpleGrid>
      <SimpleGrid className="MySitesManagement" cols={2} spacing="lg">
        {tilesToDisplay
          .filter((tile) => tile.size === StartPageTileSize.Regular)
          .map((tile) => {
            const TileComponent =
              TILES_TO_COMPONENT_MAP[
                tile.name as keyof typeof TILES_TO_COMPONENT_MAP
              ];
            return <TileComponent key={tile.name} projectId={projectId} />;
          })}
      </SimpleGrid>
    </>
  );
}

function LoadingTiles() {
  return (
    <SimpleGrid className="MySitesManagement" cols={2} spacing="lg">
      <LoadingTile />
      <LoadingTile />
    </SimpleGrid>
  );
}

export { MySitesManagement, MySitesManagementProps };
